import { render, staticRenderFns } from "./Pagemanage.vue?vue&type=template&id=9bc5e32c&scoped=true&"
import script from "./Pagemanage.vue?vue&type=script&lang=js&"
export * from "./Pagemanage.vue?vue&type=script&lang=js&"
import style0 from "./Pagemanage.vue?vue&type=style&index=0&id=9bc5e32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc5e32c",
  null
  
)

export default component.exports